import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const maxWidthClasses = {
    xs: "max-w-xs",
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
};

const ConfirmDialog = ({
    open,
    onClose,
    title,
    content,
    maxWidth = "sm",
    fullScreen = false,
    className = "",
    actions, // ✅ new prop for buttons (array of JSX)
}) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }

        return () => {
            document.body.style.overflow = "unset";
        };
    }, [open]);

    if (!open || !mounted) return null;

    // Resolve width class
    let widthClass = "";
    if (typeof maxWidth === "string") {
        if (maxWidthClasses[maxWidth]) {
            widthClass = maxWidthClasses[maxWidth];
        } else {
            widthClass = maxWidth; // custom string (e.g. "max-w-3xl")
        }
    }
    if (maxWidth === false) {
        widthClass = "max-w-none";
    }

    const dialog = (
        <div
            className={`fixed inset-0 z-9999 flex items-center justify-center ${
                fullScreen ? "p-6" : ""
            }`}
        >
            <div className="absolute inset-0 bg-black/50" onClick={onClose} />
            <div
                className={`relative bg-white transform transition-all duration-300 overflow-y-auto ${
                    fullScreen
                        ? "rounded-sm shadow-lg p-4 w-full h-full"
                        : `rounded-sm shadow-lg p-4 w-full ${widthClass}`
                } ${className}`}
            >
                {title && <div className="mb-4">{title}</div>}
                <div>{content}</div>
                {actions && (
                    <div className="mt-6 flex justify-end gap-3">{actions}</div>
                )}
            </div>
        </div>
    );

    return createPortal(dialog, document.body);
};

export default ConfirmDialog;
